/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_ArchiveInputs */

const en_user_archive = /** @type {(inputs: User_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const ja_user_archive = /** @type {(inputs: User_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

const fr_user_archive = /** @type {(inputs: User_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiver`)
};

const de_user_archive = /** @type {(inputs: User_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivieren`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {User_ArchiveInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_archive = /** @type {((inputs?: User_ArchiveInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_ArchiveInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_archive(inputs)
	if (locale === "ja") return ja_user_archive(inputs)
	if (locale === "fr") return fr_user_archive(inputs)
	return de_user_archive(inputs)
});